// extracted by mini-css-extract-plugin
module.exports = {"section_wrapper":"VvR_2","header":"jV4IQ","changecity":"J3Gy5","bottomspacing":"fjJ7d","rhs_border":"w0Ioh","inFocus":"zNveQ","rightNews":"_aMo7"};